import { IconType } from "react-icons";
import { Skeleton, Stack, Typography, Box, useTheme } from "@mui/material";
import { CARD_RADIUS, cardSurfaceSx, statIconSx } from "../common/cardStyles";

type Props = {
  title: string;
  value: number;
  Icon: IconType;
  color: string;
  loading?: boolean;
  type?: string;
};

const typeSymbol: Record<string, string> = {
  price: " د.ل",
};

const StatisticsCard = ({
  title,
  value,
  Icon,
  color,
  loading = false,
  type,
}: Props) => {
  const theme = useTheme();

  if (loading) {
    return (
      <Skeleton
        variant="rounded"
        height={104}
        sx={{ width: "100%", borderRadius: `${CARD_RADIUS}px` }}
      />
    );
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={2}
      sx={{
        ...cardSurfaceSx(theme),
        position: "relative",
        p: 2.25,
        width: "100%",
        height: "100%",
        cursor: "default",
        overflow: "hidden",
      }}
    >
      <Box sx={statIconSx(color)}>
        <Icon />
      </Box>
      <Stack flex={1} minWidth={0} gap={0.25}>
        <Typography
          variant="h5"
          noWrap
          sx={{
            fontWeight: 700,
            fontSize: "1.375rem",
            letterSpacing: "-0.02em",
            color: "text.primary",
            lineHeight: 1.2,
          }}
        >
          {new Intl.NumberFormat("en-us").format(value)}
          {type ? typeSymbol[type] : ""}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          noWrap
          sx={{ fontWeight: 500 }}
        >
          {title}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default StatisticsCard;
